/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

export default function EyeIcon({ width, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 13 10"
      fill="none"
    >
      <path
        d="M12.3453 3.82667C11.4853 2.4 9.56531 0 6.33197 0C3.09864 0 1.17864 2.4 0.325307 3.82667C0.112472 4.17982 0 4.58434 0 4.99667C0 5.409 0.112472 5.81351 0.325307 6.16667C1.17864 7.6 3.10531 10 6.33197 10C9.55864 10 11.4853 7.6 12.3453 6.16667C12.5563 5.814 12.6682 5.41095 12.6693 5C12.6673 4.58707 12.5555 4.1821 12.3453 3.82667ZM6.33197 8C5.73863 8 5.15861 7.82405 4.66526 7.49441C4.17192 7.16476 3.7874 6.69623 3.56033 6.14805C3.33327 5.59987 3.27386 4.99667 3.38962 4.41473C3.50537 3.83279 3.7911 3.29824 4.21065 2.87868C4.63021 2.45912 5.16476 2.1734 5.7467 2.05764C6.32865 1.94189 6.93185 2.0013 7.48002 2.22836C8.0282 2.45542 8.49674 2.83994 8.82638 3.33329C9.15603 3.82664 9.33197 4.40666 9.33197 5C9.33074 5.79527 9.01427 6.55762 8.45193 7.11996C7.88959 7.6823 7.12724 7.99877 6.33197 8ZM7.99197 4.90667C7.99751 4.93745 7.99974 4.96874 7.99864 5C7.99878 5.37912 7.86967 5.74696 7.6326 6.04281C7.39553 6.33867 7.06468 6.54486 6.69464 6.62736C6.32461 6.70985 5.9375 6.66373 5.59721 6.49659C5.25692 6.32945 4.98379 6.05129 4.82288 5.70801C4.66196 5.36474 4.6229 4.97686 4.71212 4.60839C4.80134 4.23992 5.01352 3.91287 5.31365 3.68123C5.61377 3.44959 5.9839 3.3272 6.36296 3.33425C6.74201 3.34129 7.10733 3.47736 7.39864 3.72C7.2802 3.77315 7.17953 3.85922 7.10862 3.96796C7.0377 4.07669 6.99953 4.20352 6.99864 4.33333C6.99864 4.51014 7.06888 4.67971 7.1939 4.80474C7.31893 4.92976 7.4885 5 7.66531 5C7.78088 5.00078 7.89426 4.96839 7.99197 4.90667Z"
        fill="#B8C7D8"
      />
    </svg>
  );
}

EyeIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

EyeIcon.defaultProps = {
  width: 13,
  height: 10,
};
